import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { track } from "@/lib/analytics";
import { useIsMobile } from "@/hooks/use-mobile";

export function FloatingPhoneButton() {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <a
      href="tel:0617105786"
      className="fixed bottom-4 left-4 z-40"
      onClick={() => track("floating_phone_click")}
    >
      <Button
        size="icon"
        className="h-14 w-14 rounded-full bg-primary hover:bg-primary/90 shadow-energy"
      >
        <Phone className="h-6 w-6" />
        <span className="sr-only">Bel direct: 06 17 10 57 86</span>
      </Button>
    </a>
  );
}